module.exports = __webpack_public_path__ + "static/s2-1-everything-d-d477b3d15d476330c264060dcc63800d.jpg";